import React__default from 'react';
import LazyImage from '../../../../Atoms/LazyImage.js';
import Typography from '../../../../Atoms/Typography.js';
import ItemPlaceHolder from "../../../../assets/item-card-placeholder-0f7c213a.jpg";

function ItemCard(_a) {
    var _b = _a.image_url, image_url = _b === void 0 ? ItemPlaceHolder : _b, item_desc = _a.item_desc, item_title = _a.item_title, onClick = _a.onClick, imageComponent = _a.imageComponent;
    return (React__default.createElement("div", { onClick: onClick, className: "landing-screen-menu__item-card" },
        React__default.createElement("div", { className: "landing-screen-menu__item-card__image-wrapper" },
            React__default.createElement(LazyImage, { src: image_url || ItemPlaceHolder, alt: item_title, classes: "landing-screen-menu__item-card__image", imageComponent: imageComponent })),
        React__default.createElement("div", { className: "landing-screen-menu__item-card__content" },
            React__default.createElement(Typography, { classes: "landing-screen-menu__item-card__title", variant: "headingOne" }, item_title),
            React__default.createElement(Typography, { classes: "landing-screen-menu__item-card__description", variant: "bodyTextOne" }, item_desc))));
}

export { ItemCard as default };
//# sourceMappingURL=item-card.component.js.map
